import { useEffect, useRef, useState } from 'react';
import { portfolioContent } from '../content/portfolioContent.js';
import { scrollToTarget } from '../scroll/scrollStore.js';

export function MiniNav({ hidden = false }) {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState('');
  const navRef = useRef(null);

  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return undefined;
    const io = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { rootMargin: '-70% 0px 0px 0px' },
    );
    io.observe(hero);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const sections = portfolioContent.navLinks
      .map((link) => document.getElementById(link.href.slice(1)))
      .filter(Boolean);
    if (!sections.length) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(`#${entry.target.id}`);
        });
      },
      { threshold: 0.45 },
    );
    sections.forEach((section) => io.observe(section));
    return () => io.disconnect();
  }, []);

  function handleClick(event, href) {
    event.preventDefault();
    scrollToTarget(href);
  }

  return (
    <nav className={`mini-nav${visible && !hidden ? ' visible' : ''}`} ref={navRef} aria-label="Section navigation">
      <div className="mini-nav-inner">
        <span className="nav-name">{portfolioContent.hero.name}</span>
        <div className="nav-links">
          {portfolioContent.navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`nav-link${active === link.href ? ' active' : ''}`}
              onClick={(event) => handleClick(event, link.href)}
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}
